import React, { useState, useEffect } from "react";
import {
  deptCertificatesColumns,
  problematicDeptCertificatesColumns,
  terminalErrorsColumns,
} from "../components/deptCertificatesToAade/deptCertificatesColumns";
import { problematicDeptCertificatesFilters } from "../components/deptCertificatesToAade/deptCertificatesFilters";
import FilterComponent from "../components/tableComponents/FilterComponent";
import DeptCertificatesToAADEComponent from "../components/deptCertificatesToAade/deptCertificatesToAadeComponent";
import * as Yup from "yup";
import axios from "axios";

const DebtCertificatesToAADE = () => {
  const [chambers, setChambers] = useState([]);
  const [filters, setFilters] = useState([]);

  useEffect(() => {
    const fetchChambers = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/getChambers`,
          { withCredentials: true },
        );

        setChambers(response.data);
      } catch (error) {
        console.error(error);
      }
    };

    fetchChambers();
  }, []);

  useEffect(() => {
    setFilters(() => ({
      filterFields: problematicDeptCertificatesFilters({ chambers }),
    }));
  }, []);

  return (
    <div
      style={{
        marginBottom: 5,
        margin: "0 auto",
        width: "80vw",
        paddingBottom: "3em",
      }}
    >
      <h2>Αναζήτηση Βεβαιωμένων Οφειλών</h2>
      <FilterComponent
        initialValues={{ status: "", chamberId: "", year: 0 }}
        filterFields={problematicDeptCertificatesFilters({ chambers })}
        changeFilters={setFilters}
        validationSchema={Yup.object()}
      />
      <h2>Προβληματικές</h2>
      <DeptCertificatesToAADEComponent
        endpoint="problematicData"
        filters={filters}
        setFilters={setFilters}
        deptCertificatesColumns={problematicDeptCertificatesColumns}
        showCheckbox={true}
        isProblematic={true}
        downloadUrl={`${
          process.env.REACT_APP_BACKEND_URL
        }/downloadProblematicDebtCertificatesToAADE?${
          filters.chamberId ? `chamber=${filters.chamberId}&` : ""
        }${filters.status ? `status=${filters.status}&` : ""}${filters.year ? `year=${filters.year}&` : ""}`}
      />
      <h2>Τερματικά Σφάλματα</h2>
      <DeptCertificatesToAADEComponent
        endpoint="terminalErrors"
        filters={filters}
        setFilters={setFilters}
        deptCertificatesColumns={terminalErrorsColumns}
        showCheckbox={false}
        isProblematic={false}
        downloadUrl={`${
          process.env.REACT_APP_BACKEND_URL
        }/downloadTerminalErrors?${
          filters.chamberId ? `chamber=${filters.chamberId}&` : ""
        }${filters.status ? `status=${filters.status}&` : ""}${filters.year ? `year=${filters.year}&` : ""}`}
      />
      <h2>Μη Προβληματικές</h2>
      <DeptCertificatesToAADEComponent
        endpoint="totalData"
        filters={filters}
        setFilters={setFilters}
        deptCertificatesColumns={deptCertificatesColumns}
        showCheckbox={false}
        isProblematic={false}
        downloadUrl={`${
          process.env.REACT_APP_BACKEND_URL
        }/downloadDebtCertificatesToAADE?${
          filters.chamberId ? `chamber=${filters.chamberId}&` : ""
        }${filters.status ? `status=${filters.status}&` : ""}${filters.year ? `year=${filters.year}&` : ""}`}
      />
    </div>
  );
};

export default DebtCertificatesToAADE;
